import moment, { Moment } from 'moment'
import {
  Component,
  Mixins,
  Prop,
  Ref,
  Vue,
  Watch,
} from 'vue-property-decorator'

@Component
export default class DateInput extends Vue {
  @Ref()
  private pickerMenu!: any

  @Prop({ required: true })
  private value!: moment.MomentInput

  @Prop({ default: 'DD.MM.YYYY' })
  private displayFormat!: string

  @Prop({ default: 'YYYY-MM-DD' })
  private modelFormat!: string

  @Prop({ default: '' })
  private name!: string

  @Prop({ default: '' })
  private rules!: string

  @Prop({ default: () => [] })
  private errors!: any[]

  private menu = false
  private model = this.formatDate(this.value)
  private displayModel = this.formatDisplayDate(this.value)

  @Watch('value')
  private valueChanged(val: moment.MomentInput) {
    this.model = this.formatDate(val)
    this.displayModel = this.formatDisplayDate(val)
  }

  private dateSelected() {
    this.pickerMenu.save(this.model)
    this.$emit('input', this.model)
  }

  private formatDate(val: moment.MomentInput) {
    return moment(val, this.modelFormat).format(this.modelFormat)
  }

  private formatDisplayDate(val: moment.MomentInput) {
    return moment(val, this.modelFormat).format(this.displayFormat)
  }

  private assignDisplayDate() {
    const parts = this.displayModel.split('.')
    if (parts.length === 3) {
      parts[0] = parts[0].padStart(2, '0') // Ensure day has 2 digits
      parts[1] = parts[1].padStart(2, '0') // Ensure month has 2 digits
      this.displayModel = parts.join('.')
    }

    if (!moment(this.displayModel, this.displayFormat, true).isValid()) {
      this.displayModel = moment().format(this.displayFormat)
    }
    this.model = moment(this.displayModel, this.displayFormat).format(
      this.modelFormat
    )

    this.$emit('input', this.model)
  }

  private toggleDatePicker() {
    this.menu = !this.menu
  }
}
